import { useCallback } from 'react';

import Tasks from 'APP/Tasks';
import { StickerPackPopup } from 'APP/main/PopupManager/Popups/StickerPackPopup/StickerPackPopup';
import { ISticker } from 'APP/model/stickers/stickersModel.types';

interface IStickerPayloadPresenter {
  onOpenStickerPack(sticker: ISticker): void;
}

export function useStickerPayloadPresenter(): IStickerPayloadPresenter {
  const onOpenStickerPack = useCallback((sticker: ISticker): void => {
    Tasks.app.openPopup(StickerPackPopup, { params: { stickerPackId: sticker.stickerPackId } });
  }, []);

  return { onOpenStickerPack };
}
